import type { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

export interface InlineFetchingIndicatorProps extends HTMLAttributes<HTMLSpanElement> {
  label?: ReactNode;
}

export function InlineFetchingIndicator({ label = 'در حال به‌روزرسانی', className, ...rest }: InlineFetchingIndicatorProps) {
  return (
    <span className={clsx('vania-inline-fetching', className)} role="status" {...rest}>
      <i aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
